export enum NFSeStatus {
    ProcessandoAutorizacao = 'processando_autorizacao',
    RequisicaoInvalida = 'requisicao_invalida',
    Autorizado = 'autorizado',
    Cancelado = 'cancelado',
    ErroAutorizacao = 'erro_autorizacao',
    NFeCancelada = 'nfe_cancelada',
    ErroCancelamento = 'erro_cancelamento'
  }